import { useTranslation } from 'react-i18next';
import { Badge, BadgeVariantProps } from '@/Domain/components/Shared/Badge/Badge';
import { SonyDocumentStatusEnum } from '@/UI/KnowledgeBase/SonyDocuments/SonyDocuments.dto';

const STATUS_VARIANTS: Record<SonyDocumentStatusEnum, NonNullable<BadgeVariantProps['variant']>> = {
  [SonyDocumentStatusEnum.DEPLOYED]: 'success',
  [SonyDocumentStatusEnum.IN_RETRAIN]: 'warning',
  [SonyDocumentStatusEnum.RETRAIN_CONTENT_READY]: 'warning',
  [SonyDocumentStatusEnum.APP_ARTICLES_CREATED]: 'info',
  [SonyDocumentStatusEnum.SUPERSEDED]: 'outline',
  [SonyDocumentStatusEnum.BATCH_RETRAIN_STARTED]: 'warning',
  [SonyDocumentStatusEnum.FAIL]: 'error',
  [SonyDocumentStatusEnum.SAVED]: 'secondary',
  [SonyDocumentStatusEnum.STAGED]: 'secondary',
  [SonyDocumentStatusEnum.ARCHIVED]: 'outline',
};

type Props = {
  status: SonyDocumentStatusEnum;
  className?: string;
};

export const SonyDocumentStatusBadge = ({ status, className }: Props) => {
  const { t } = useTranslation('sony_admin');

  return (
    <Badge
      variant={STATUS_VARIANTS[status] ?? 'secondary'}
      className={className}
      data-testid="sony-document-status-badge"
      data-status={status}
    >
      <span className="whitespace-nowrap text-xs">{t(`status.${status}`)}</span>
    </Badge>
  );
};
